import {Component, ViewChild, OnInit} from '@angular/core';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import * as firebase from 'firebase';
@Component({
  selector: 'app-adminnoticias',
  templateUrl: './adminnoticias.component.html',
  styleUrls: ['./adminnoticias.component.scss']
})
export class AdminnoticiasComponent implements OnInit {

  user;
  userId = '';
  ampa;

  // datos de la tabla
  displayedColumns = ['select','imagen','titulo', 'fecha', 'acciones'];


  selection = new SelectionModel<NoticiasData>(true, []);
  dataSource: MatTableDataSource<NoticiasData>;
  noticias: NoticiasData[] = [];
  initialSelection = [];
  allowMultiSelect = true;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor( private router: Router ) {
    console.log('constructor')
  }

   ngOnInit() {

     console.log('ngoninit')
     this.dataSource = new MatTableDataSource(this.noticias);
     this.dataSource.paginator = this.paginator;
     this.dataSource.sort = this.sort;
     //obtener datos del usuario admin logueado
     this.userId = localStorage.getItem('userId');
     console.log('UserId', this.userId);
     if(!this.userId){
       this.router.navigate[('')]
     } else {
       firebase.firestore().collection('admins').doc(this.userId)
       .get()
       .then((doc)=>{
         this.user = doc.data();
         console.log('User', this.user)

         this.obtenerNoticias();
       })
     }
  }

  // nos traemos los noticias del ampa utilizando el id de ampa que tiene el usuario en su documento
  obtenerNoticias(){
    console.log('obtenerNoticias')
    firebase.firestore().collection('noticias')
    .where('ampa','==', this.user.ampa)
    .get()
    .then((snapshot)=>{

      snapshot.forEach((doc)=>{
        console.log('doc',doc)
        //var elemento: NoticiasData;
        var elemento = doc.data();
        elemento.id = doc.id;
        //hacemos el push
        this.noticias = [...this.noticias, <NoticiasData>elemento];
      })
      this.dataSource = new MatTableDataSource(this.noticias);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    })
  }



  // mostramos los datos del noticia id
  ver(row){
    console.log('Ver ', row.id);
    this.router.navigate(['/admin/noticias/ver/' + row.id]);
  }

  // eliminar noticias seleccionados
  eliminar(){
      this.selection.selected.forEach((noticia) => {
        firebase.firestore().collection('noticias').doc(noticia.id)
        .delete()
        .catch(error => {console.log(error); })
        .then(()=>{
          console.log('Borrada noticia ' + noticia.id)
        })
      });
      this.noticias = [];
      this.obtenerNoticias();
  }

  // actualizamos los datos de algunos campos del noticia id
  editar(row){
    console.log('Editado ', row.id)
    this.router.navigate(['/admin/noticias/editar/' + row.id])
  }

  //exportamos a xlsx datos de noticias seleccionados
  exportToExcel() {
    var ws = XLSX.utils.json_to_sheet(this.selection.selected);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Noticias");
    XLSX.writeFile(wb, 'noticias.xlsx');
  }

  exportToPDF() {

  }


  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected == numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
    this.selection.clear() :
    this.dataSource.data.forEach(row => this.selection.select(row));
  }
}

export interface NoticiasData {
  id: string;
  titulo: string;
  descripcion: string;
  imagen: string;
  fecha: string
  }


// WEBPACK FOOTER //
// ./src/app/adminnoticias/adminnoticias.component.ts